import LovrFire from '../lovrfire'

var flag1 = 0;
var flag2 = 0;

export const getAllCreatorsByTag = async (tags) => {
    let creators = []

    if (tags.length == 0) {
        const g1tags = [
            "Kinky",
            "Fetish",
            "Asian",
            "BDSM",
            "Cosplay",
            "Big ass",
            "Big tits",
            "Latina",
            "Teen",
            "Pornstar",
            "Gay/Lesbian",
            "Ebony",
            "Amateur",
            "Mature",
            "MILF"
        ]
        const g1 = LovrFire.firestore().collection('users').where('isCreator', '==', true).orderBy('followersCount', 'desc');;
        (await g1.get()).docs.forEach(creator => {
            creators.push(creator.data())
        })

    } else {
        try {
            const g1 = LovrFire.firestore().collection('users').where('isCreator', '==', true).orderBy('followersCount', 'desc');;
            (await g1.get()).docs.forEach(creator => {
                for (var i = 0; i < tags.length; i++) {
                    if (!creator.data().tags.includes(tags[i])) {
                        flag1 = 1;
                        break;
                    } else {
                        flag1 = 0;
                    }
                }
                if (flag1 == 0)
                    creators.push(creator.data())
            })
        } catch (e) {
            console.log(e);
        }
    }

    var jsonObject = creators.map(JSON.stringify);
    var uniqueSet = new Set(jsonObject);
    var uniqueArray = Array.from(uniqueSet).map(JSON.parse);
    return uniqueArray
}

export const getCreatorsByUsername = async (query, isCreator) => {

    var queryResult = null;
    if (!isCreator)
        queryResult = await LovrFire.firestore().collection('users').where('isCreator', '==', true).orderBy('followersCount', 'desc').get();
    else
        queryResult = await LovrFire.firestore().collection('users').orderBy('followersCount', 'desc').get();



    return queryResult;
}

export const getTrendingPosts = (observer) => {
    return LovrFire.firestore().collection('posts').orderBy('likesCount').orderBy('time', 'desc').onSnapshot(observer);
}